//
//This module is used to store restaurants into local storage
//

function storeRestaurants(restaurants) {
    localStorage.setItem("restaurants", JSON.stringify(restaurants));
}

function getRestaurants() {
    let restaurants = localStorage.getItem("restaurants");
    return JSON.parse(restaurants);
}

function clearRestaurantsInfo() {
    localStorage.removeItem("restaurants");
}

export default {
    name: 'loginStorage',
    storeRestaurants,
    getRestaurants,
    clearRestaurantsInfo
} 